import { getVariant } from '../organism/ABFeature/Feature';

const getShowCodConvenienceFlowFlag = (showCodConvenienceFeeFlow: string) => {
  if (showCodConvenienceFeeFlow === 'ON') {
    // Master Flag for COD Convenience
    if (window.convenienceFee) {
      // Checking whether Experiment exists or not
      return getVariant('convenienceFee'); // If Yes then returning true if variant is 1
    }
  }
  return showCodConvenienceFeeFlow === 'ON'; // Base Case if Master flag is OFF
};

export default getShowCodConvenienceFlowFlag;
